const selectors = {
    el: '.js-artist-images:not(.is-initialized)',
    image: '.js-artist-images-image',
    lazyloaded: '.lazyloaded'
};

const classes = {
    hidden: 'is-hidden'
}
const build = (el) => {
    const images = el.querySelectorAll(selectors.image);
    let interval = null;
    let i = images.length - 1;

    el.addEventListener('mouseenter', () => {  
        interval = setInterval(() => {
            if (images[i].querySelector(selectors.lazyloaded)) {
                images[i].classList.add(classes.hidden);
            }
            i--;
            
            if (i === -1) {
                i = images.length - 1
            }

            images[i].classList.remove(classes.hidden);
        }, 200);
    });

    el.addEventListener('mouseleave', () => {
        clearInterval(interval);
    });
}

const init = () => {
    const els = document.querySelectorAll(selectors.el);
    els.forEach(el => {
        el.classList.add('is-initialized');
        build(el);
    });
};

const module = () => {
    init();
    document.addEventListener('domUpdated', init);
};

export default module;